import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AnimatedBack from "../images/AnimatedBack.gif";
import Saas1 from "../images/Saas1.png";
import Saas2 from "../images/Saas2.png";
import Saas3 from "../images/Saas3.png";
import Saas4 from "../images/Saas4.png";
import Saas5 from "../images/Saas5.png";
import Saas6 from "../images/Saas6.png";
import Saas7 from "../images/Saas7.png";
import Saas8 from "../images/Saas8.png";

function SaaS() {
  return (
    <>
      <Header />
      <div className="WebD">
        <div className="Webd-above">
          <img className="Webd-img" src={AnimatedBack} alt="" />
          <div className="Webd-above-info">
            <p className="Webd-p">SaaS Development</p>
            <p
              className="Webd-p"
              style={{ marginTop: "10px", marginBottom: "20px" }}
            >
              Company
            </p>
            <p className="Webd-p1">
              We are a comprehensive SaaS application development company,
              offering end-to-end solutions.
            </p>
          </div>
        </div>
        <div className="Gd-main">
          <p className="Gd-main-p" style={{color:"black"}}>
            Purohit Technosoft is committed to developing high-quality,
            innovative deep-tech SaaS products. With our extensive experience in
            delivering world-class solutions, focused on analytics and best
            practices, we bring a unique understanding to the launch and support
            process. Let’s collaborate to turn your dream ventures into reality
            and achieve success together.
          </p>
        </div>
        <div className="Webd-main2">
          <p className="Webd-main2-p">Our SaaS Development Services</p>
          <p className="Webd-main2-p1">
            We design SaaS software for new applications and also specialize in
            re-designing existing apps to seamlessly integrate into the SaaS
            environment.
          </p>
          <div className="Appd-main2-boxes">
            <div className="Appd-main2-box" style={{backgroundColor:"#d8f3dc"}}>
              <img style={{borderRadius:"20px"}} className="Appd-main2-img" src={Saas1} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Design and development of SaaS applications
              </p>
              <p style={{ marginTop: "20px" }}>
                We offer comprehensive SaaS design and development services,
                transforming your unique idea into a robust, scalable, and
                user-friendly application.
              </p>
            </div>
            <div className="Appd-main2-box" style={{backgroundColor:"#fff2b2"}}>
              <img style={{borderRadius:"20px"}} className="Appd-main2-img" src={Saas2} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Multi-Tenant SaaS Architecture Design
              </p>
              <p style={{ marginTop: "20px" }}>
                We help technology providers create robust SaaS products by
                designing and implementing diverse delivery models and
                management solutions.
              </p>
            </div>
            <div className="Appd-main2-box" style={{backgroundColor:"#b6ccfe"}}>
              <img style={{borderRadius:"20px"}} className="Appd-main2-img" src={Saas3} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Third-Party Integration Services
              </p>
              <p style={{ marginTop: "20px" }}>
                Purohit Technosoft integrates your SaaS software with
                third-party solutions, connecting external data sources and
                enabling seamless payment and gateway options.
              </p>
            </div>
          </div>
          <div className="Appd-main2-boxes">
            <div className="Appd-main2-box" style={{backgroundColor:"#f9bec7"}}>
              <img style={{borderRadius:"20px"}} className="Appd-main2-img" src={Saas4} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                SaaS App Development Consulting
              </p>
              <p style={{ marginTop: "20px" }}>
                We offer end-to-end technical and strategic consulting to
                streamline SaaS application development and help you achieve
                your business goals.
              </p>
            </div>
            <div className="Appd-main2-box" style={{backgroundColor:"#cfe1b9"}}>
              <img style={{borderRadius:"20px"}} className="Appd-main2-img" src={Saas5} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Technology Re-engineering and Migration
              </p>
              <p style={{ marginTop: "20px" }}>
                We leverage expertise in AI, IoT, blockchain, mobile, web, and
                cloud to seamlessly upgrade your existing SaaS to cutting-edge
                technology.
              </p>
            </div>
            <div className="Appd-main2-box" style={{backgroundColor:"#f2daff"}}>
              <img style={{borderRadius:"20px"}} className="Appd-main2-img" src={Saas6} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Maintenance and Support
              </p>
              <p style={{ marginTop: "20px" }}>
                Our development team continuously adds new features and provides
                ongoing maintenance, ensuring your SaaS solution remains updated
                and fully supported.
              </p>
            </div>
          </div>
        </div>
        <img
  src={Saas7}
  alt=""
  style={{
    display: "block",
    margin: "100px auto", // top spacing + center horizontally
    padding: "0 20px",    // safe space on mobile edges
    width: "100%",        // responsive width
    maxWidth: "1000px",   // limit on desktop
    height: "auto",       // keeps aspect ratio
    borderRadius: "30px",
    boxShadow: "0 0 12px rgba(0,0,0,0.1)",
  }}
/>

        <div className="Webd-main2">
          <p className="Webd-main2-p">Our SaaS Application Development Process</p>
          <p className="Webd-main2-p1">
          Deliver the best SaaS solution tailored to your needs using the following approach.
          </p>
          <img
  src={Saas8}
  alt=""
  style={{
    display: "block",
    margin: "40px auto",       // centered + top/bottom spacing
    padding: "0 20px",         // safe side padding for mobile
    maxWidth: "1000px",        // desktop size limit
    width: "100%",             // fluid for smaller screens
    height: "auto",
    objectFit: "cover",
    borderRadius: "12px",      // optional modern look
  }}
/>

          </div>
      </div>
      <Footer />
    </>
  );
}

export default SaaS;
